export default __webpack_public_path__ + "static/inventory-accuracy-c20c057a44db115a6dfe75ccb1c9a755.jpg";